<H1
  >Links
  <button
    mat-raised-button
    class="button-primary-action"
    routerLink="/admin/links/add"
    style="float: right"
  >
    Nieuwe link
  </button>
</H1>

<mat-form-field>
  <mat-label>Filter</mat-label>
  <input matInput (keyup)="applyFilter($event)" placeholder="Zoeken" #input />
</mat-form-field>

<app-http-loader [componentId]="componentId">
  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Naam</th>
        <td mat-cell *matCellDef="let element">{{ element.title }}</td>
      </ng-container>
      <ng-container matColumnDef="linkTypeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Categorie</th>
        <td mat-cell *matCellDef="let element">{{ element.linkTypeName }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="row-hover-highlight"
        [routerLink]="['/admin/links/', row.id, 'edit']"
      ></tr>
    </table>

    <mat-paginator
      showFirstLastButtons
      [pageSizeOptions]="[5, 10, 20]"
      [pageSize]="10"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
</app-http-loader>
